import { NoTrucksFooter, NoTrucksList, NoTrucksMessageContainer, NoTrucksTitle } from "./NoTrucksMessage.styles";
import {
	CheckYourSearchSpellingText,
	NoTrucksFirstBulletText,
	NoTrucksListText,
	NoTrucksThirdBulletText,
	NoTrucksTitleText,
	PleaseContactSalesRepText
} from "constants/text";

const NoTrucksMessage = () => {
	return (
		<NoTrucksMessageContainer>
			<img
				src="/assets/trucks/TruckIllustration.svg"
				alt="Processed trucks not found logo"
				data-testid="processed-trucks-not-found-logo"
			/>
			<NoTrucksTitle>{NoTrucksTitleText}</NoTrucksTitle>
			<NoTrucksList>
				<li>{NoTrucksListText}</li>
				<li>{NoTrucksFirstBulletText}</li>
				<li>{CheckYourSearchSpellingText}</li>
				<li>{NoTrucksThirdBulletText}</li>
			</NoTrucksList>
			<NoTrucksFooter>{PleaseContactSalesRepText}</NoTrucksFooter>
		</NoTrucksMessageContainer>
	);
};

export default NoTrucksMessage;
